import { cloneDeep, isArray, mergeWith } from 'lodash'
import { StateCreator } from 'zustand'

import { EClientPath } from '~/models/api'
import EStoreStateKeys from '~/models/store'

type TUserDefinition = {
  id: string
  partnerId: string
  organizationId: string
  signInRedirectPath: EClientPath | null
  referredBy: string
  impersonatorsOrgId?: string
  impersonatorsUserId?: string
}

type TUser = {
  [EStoreStateKeys.user]: TUserDefinition
}

export type TUserState = TUser & {
  setUser(user: Partial<TUserDefinition>): void
}

export const initialUserState: TUserDefinition = {
  id: '',
  organizationId: '',
  partnerId: '',
  signInRedirectPath: null,
  referredBy: '',
  impersonatorsOrgId: '',
  impersonatorsUserId: '',
}

const createUserSlice: StateCreator<
  TUserState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  user: cloneDeep(initialUserState),
  setUser: (user) =>
    set(
      (state) => ({
        user: mergeWith(cloneDeep(state.user), user, (objValue, srcValue) => {
          if (isArray(objValue)) {
            return srcValue
          }
          // eslint-disable-next-line consistent-return
          return undefined
        }),
      }),
      undefined,
      {
        type: 'setUser',
        user,
      },
    ),
})

export default createUserSlice
